// extracted by mini-css-extract-plugin
export default {"font":"Cart_font__QlpZS","button":"Cart_button__-Zbex","primary":"Cart_primary__2G2RY"};